/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Manual_SeriesInputs */

const vi_einvoice_manual_series = /** @type {(inputs: Einvoice_Manual_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ký hiệu`)
};

/**

* @param {Einvoice_Manual_SeriesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_manual_series = /** @type {((inputs?: Einvoice_Manual_SeriesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Manual_SeriesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_manual_series(inputs)
});